import { render, staticRenderFns } from "./SaderatBankAccountsAccessModal.vue?vue&type=template&id=1a31deb7&scoped=true"
import script from "./SaderatBankAccountsAccessModal.vue?vue&type=script&lang=js"
export * from "./SaderatBankAccountsAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31deb7",
  null
  
)

export default component.exports